module.exports = __webpack_public_path__ + "img/16.d1e03e0d.png";